// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__LvuXh","logo-text":"Logo_logo-text__a24ib"};